import { useEffect } from "react";
import { bindServiceWorkerMessages, enablePush } from "@/lib/push";

// Branche les Web Push pour le poste courant : abonnement silencieux si déjà autorisé,
// sinon demande de permission à la première interaction utilisateur (geste requis navigateur).
export function useWebPush(slug) {
  useEffect(() => {
    if (!slug) return;
    bindServiceWorkerMessages();
    enablePush(slug, true);
    const onFirst = () => { enablePush(slug, false); window.removeEventListener("pointerdown", onFirst); };
    if (typeof Notification !== "undefined" && Notification.permission === "default") {
      window.addEventListener("pointerdown", onFirst, { once: true });
    }
    return () => window.removeEventListener("pointerdown", onFirst);
  }, [slug]);
}
